<template>
  <!-- 小组公告弹窗 -->
  <div class="vmp-group-notice">
    <vh-dialog
      :visible="dialogVisible"
      @open="handlOpen"
      :before-close="handleClose"
      :close-on-click-modal="false"
      width="500px"
    >
      <template slot="title">
        <span class="title">{{ $t('host.k_551001') }}</span>
        <div class="help-icon">
          <i class="vh-tooltip vh-iconfont vh-line-question"></i>
          <div class="help-tooltip">
            <p>{{ $t('host.k_551002') }}</p>
            <p>{{ $t('host.k_551003') }}</p>
          </div>
        </div>
      </template>

      <vh-input
        type="textarea"
        :rows="10"
        :placeholder="$t('host.k_551004')"
        v-model="content"
        maxlength="300"
        show-word-limit
      ></vh-input>

      <!-- 底部按钮 -->
      <div slot="footer" class="vmp-group-ft">
        <vh-button plain type="info" :round="true" @click="handleClose">
          {{ $t('host.k_551005') }}
        </vh-button>
        <vh-button type="primary" :round="true" @click="handleThrottleSubmit()">
          {{ $t('host.k_551006') }}
        </vh-button>
      </div>
    </vh-dialog>
  </div>
</template>
<script>
  import { useNoticeServer } from 'middle-domain';
  import { throttle } from 'lodash';

  export default {
    name: 'VmpGroupNotice',
    props: {
      show: {
        type: Boolean,
        default: false
      }
    },
    data() {
      return {
        dialogVisible: this.show,
        content: ''
      };
    },
    beforeCreate() {
      this.noticeServer = useNoticeServer();
    },
    watch: {
      show: function (newVal) {
        this.dialogVisible = newVal;
      }
    },
    mounted() {
      this.handleThrottleSubmit = throttle(this.handleSubmit, 300, { trailing: false });
    },
    methods: {
      handlOpen() {
        this.content = '';
      },
      handleSubmit: async function () {
        const fmtContent = this.content.trim();
        if (fmtContent.length === 0) {
          this.$message.warning(this.$t('host.k_551007'));
          return;
        }
        try {
          await this.noticeServer.sendNotice({
            content: fmtContent,
            messageType: 2
          });
          this.handleClose();
        } catch (ex) {
          console.log('-----ex----', ex);
        }
      },
      handleClose() {
        this.dialogVisible = false;
        this.$emit('update:show', false);
      }
    }
  };
</script>
<style lang="less">
  .vmp-group-notice {
    .vh-dialog__header {
      color: #1a1a1a;
      .title {
        font-size: 20px;
      }
      .help-icon {
        margin-left: 5px;
        display: inline;
        position: relative;
      }
      .help-tooltip {
        position: absolute;
        font-size: 12px;
        z-index: 1;
        left: 24px;
        top: -15px;
        padding: 6px;
        border-radius: 4px;
        width: 340px;
        background-color: #333;
        color: #fff;
        transition: all 0.5s;
        visibility: hidden;
        opacity: 0;
      }
      .help-icon:hover {
        .help-tooltip {
          visibility: visible;
          opacity: 1;
        }
      }
    }
    .vmp-group-ft {
      text-align: right;
    }
  }
</style>
